import { FormHelperText, Stack } from '@mui/material';
import React, { FC } from 'react';

import { TopicBasicFragment } from '../../../../../generated/graphql';

import translate from '../../../../../i18n/translate';
import ComposeMetaTopicTrigger from '../ComposeMetaTopicTrigger';

type Props = {
  shouldValidate?: boolean;
  topic?: TopicBasicFragment;
};

/**
 * Section in the template compose that displays the topics
 *
 * @param props                Props passed to the component
 * @param props.shouldValidate Whether the input should be validated
 * @param props.topic          Currently selected topic
 * @returns                    The component itself
 */
const ComposeMetaTopics: FC<Props> = ({ shouldValidate = true, topic }) => {
  const topicTitle = topic?.title;
  const shouldShowError = topic === undefined && shouldValidate;

  return (
    <Stack>
      <ComposeMetaTopicTrigger
        heading={translate('GENERAL__IN')}
        shouldShowError={shouldShowError}
        topicTitle={topicTitle}
      >
        {topicTitle ?? translate('GENERAL__SELECT_TOPIC')}
      </ComposeMetaTopicTrigger>
      {shouldShowError && (
        <FormHelperText error={true} variant="filled">
          {translate('GENERAL__FILL_FIELD')}
        </FormHelperText>
      )}
    </Stack>
  );
};

export default ComposeMetaTopics;
